<template>
  <section>
    <b-table :data="list" :loading="loading" striped>
      <template slot-scope="props">
        <b-table-column label="Name">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column label="Actions" :width="200">
          <button class="button" @click="remove(props.row.id)">
            Remove
          </button>
        </b-table-column>
      </template>
      <template slot="empty" v-if="!loading">
        <empty />
      </template>
    </b-table>
  </section>
</template>

<script>
import http from '@/lib/utils/http'
import Empty from '@/lib/components/Empty'

export default {
  data() {
    return {
      list: [],
      loading: false,
    }
  },
  components: {
    empty: Empty,
  },
  methods: {
    load() {
      this.loading = true
      return http
        .get('partners')
        .then(resp => (this.list = resp.data))
        .catch(() => {})
        .then(() => (this.loading = false))
    },
    remove() {
      this.loading = true
      http
        .delete('partners')
        .then(() => this.load())
        .catch(() => {})
        .then(() => (this.loading = false))
    },
  },
  created() {
    this.load()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Partners/List.vue